import './product-overview.scss';
import AjaxLoad from '../../utilities/js/ajax-loader';
import { setActiveFilterItem } from '../../utilities/js/setActiveFilterItem';
import { Fieldset } from '../../components/fieldset/fieldset';

class ProductOverview {
    constructor ($productOverview, settings) {
        this.$productOverview = $productOverview;
        this.$productContainer = this.$productOverview.querySelector('[data-product-overview="product-container"]');
        this.$productComponents = this.$productOverview.querySelector('[data-product-overview="product-components"]');

        this.$filterList = this.$productOverview.querySelector('[data-product-overview="filter-list"]');
        this.$fieldsetSelect = this.$productOverview.querySelector('[data-product-overview="fieldset-select"]');
        this.$filterBarSelect = this.$productOverview.querySelector('[data-product-overview="select"]');

        this.$filterItems = this.$productOverview.querySelectorAll('[data-filter-item]');

        this.sideLabel = window.sideLabelOverview;
        this.isLoading = false;
        this.requestTimestamp = Date.now();
    }

    initialize () {
        if (this.$productContainer && this.$productComponents) {
            if (this.$fieldsetSelect) {
                const fieldset = new Fieldset(this.$fieldsetSelect);
                fieldset.initialize();
                this.choice = fieldset.choice;
            }
            this.bindEvents();
        }
    }

    bindEvents () {
        if (this.$filterBarSelect) {
            this.$filterBarSelect.addEventListener('change', (e) => {
                const $selectedOption = this.$filterBarSelect.options[e.srcElement.selectedIndex];

                if ($selectedOption) {
                    const uri = $selectedOption.value;
                    this.submitRequest(uri);

                    // sync desktop filter button
                    const $filterItem = this.$filterList.querySelector('a[href="' + uri + '"]');
                    setActiveFilterItem(this.$filterItems, $filterItem.parentNode);
                }
            });
        }

        const addFilterItemEvents = ($filterItem) => {
            $filterItem.addEventListener('click', (e) => {
                e.preventDefault();
                const $link = $filterItem.querySelector('a');
                if ($link) {
                    const uri = $link.getAttribute('href');
                    this.submitRequest(uri);
                    setActiveFilterItem(this.$filterItems, $filterItem);

                    // sync mobile choices element
                    this.choice.setChoiceByValue(uri);
                }
            });
        };

        for (let i = 0; i < this.$filterItems.length; i++) {
            const $filterItem = this.$filterItems[i];

            addFilterItemEvents($filterItem);
        }
    }

    submitRequest (uri) {
        if (this.isLoading) {
            return false;
        }
        this.isLoading = true;

        this.$productContainer.classList.add('product-overview__products--hidden');
        this.requestTimestamp = Date.now();

        new AjaxLoad(uri, { // eslint-disable-line
            requestMethod: 'GET',
            onSuccess: (result) => {
                const responseJson = JSON.parse(result);
                const filterName = responseJson.filterName;
                const $filterItem = this.$productOverview.querySelector(`[data-filter-item="${filterName}"]`);

                this.swapProduct(responseJson.html);
                this.updateSideLabel(filterName);

                if ($filterItem) {
                    setActiveFilterItem(this.$filterItems, $filterItem);
                }

                this.$productContainer.classList.remove('product-overview__products--hidden');
                this.isLoading = false;
            }
        });
    }

    swapProduct (html) {
        this.$productComponents.innerHTML = html;

        const contentUpdateEvent = new CustomEvent('content.loaded', {
            view: window,
            bubbles: true,
            cancelable: false,
            detail: {
                $context: this.$productComponents
            }
        });

        window.dispatchEvent(contentUpdateEvent);

        const now = Date.now();
        const requestTimeDifference = now - this.requestTimestamp;
        const minimalWaitingTime = 1000;

        if (requestTimeDifference >= minimalWaitingTime) {
            this.$productContainer.classList.remove('product-overview__products--hidden');
        } else {
            setTimeout(() => {
                this.$productContainer.classList.remove('product-overview__products--hidden');
            }, minimalWaitingTime - requestTimeDifference);
        }
    }

    updateSideLabel (filterName) {
        // update side label on submit success
        if (this.sideLabel) {
            this.sideLabel.$filterName.textContent = filterName;
            this.sideLabel.updateAnchorList();
            this.sideLabel.handlePositioning();
        }
    }
}

export { ProductOverview };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-product-overview="root"]');
        $$roots.forEach($root => {
            const $rootAPI = new ProductOverview($root);
            $rootAPI.initialize();
        });
    }
});
